module.exports = __webpack_public_path__ + "static/media/down.11775806.svg";